<template>
  <div class="campainRange">
    <div class="CampaignBus">
      <div class="CampaignBus__header">
        <div class="CampaignBus__header__left">
          <div class="CampaignBus__header__left__search">
            <i class="adx-ic_search"></i>
            <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
          </div>
          <adx-dropdown-list class="status" 
            @selected="selectedStatus" 
            :valueDisplay="selectedStatusValue" 
            :list="statusList" 
            :labelButton="labelStatus" 
            :isCustomSet="isSelected" />
          <button v-if="filtered" class="btn-regular primary" @click="resetFilter">Reset</button>
        </div>
        <div class="CampaignBus__header__right">
          <p>Sort by :</p>
          <div>
            <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" @selected="selectedSortStatus" :options="sort"></adx-dropdown-sort>
          </div>
        </div>
      </div>
    </div>
    <adx-table text="Tooltip button" 
      :loading.sync="isLoading"
      :items.sync="data"  
      :isEmpty.sync="isEmpty"  
      @selectedAction="selectedAction"
      @downloadBast="downloadBast">
    </adx-table>

    <div class="CampaignBus__footer">
      <div class="range" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Campaigns</div>
      <adx-pagination 
        v-if="!isLoading && !isEmpty"
        :max-page="maxPage"
        :selected-page="selectedPage"
        @change-page="selectPage"
      />
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import DropdownSort from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import table from '@/components/Table'
import LabelStatus from '@/components/StatusLabel'

import { parseErrorGql } from '@/lib/error'
import lib from '@/lib/util'
import { helpers } from '@/lib/validation/'
import { mapGetters } from 'vuex'

export default {
  name: 'adx-campaign-bus',
  components: {
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-dropdown-sort': DropdownSort,
    'adx-dropdown-list': ListDropdown,
    'adx-table': table, LabelStatus,
  },
  props: {

  },
  data() {
    return {
      retryCount: 0,
      bastloading: 0,
      eventBast: false,
      eventMeasurement: false,
      measurementData: null,
      isLoading: true,
      searchBoxValue:'',
      selectedStatusValue:'',
      selectedStatusLabel:'',
      selectedPage: 1,
      resetPage: false,
      currentPage: 1,
      count: 0,
      isSelected: false,
      maxPage: 1,
      bast: [],
      selectedSortValue: '',
      labelStatus: 'All Status',
      sort: [
        {
          'id': 0,
          'label': 'Created Date',
          'value': 'first_added'
        },
        {
          'id': 1,
          'label': 'Last Updated',
          'value': 'last_updated'
        },
      ],
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text",
            display: "display:none;"
          },
          {
            title: "STATUS",
            type: "statuslabel"
          },
          {
            title: "CAMPAIGN NAME",
            type: "text"
          },
          {
            title: "PERIOD",
            type: "period"
          },
          {
            title: "",
            type: "button"
          },
          {
            title: "",
            type: "icon"
          },
          {
            title: "",
            type: "icon"
          },
          {
            title: "",
            type: "icon"
          }
        ],
        body : []
      },
      statusList: [
        {
          id: 0,
          label: 'All',
          value: null
        },
        {
          id: 1,
          label: 'Upcoming',
          value: "upcoming"
        },
        {
          id: 2,
          label: 'Active',
          value: "active"
        },
        {
          id: 3,
          label: 'Expired',
          value: "expired"
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    isEmpty: function(){
      return this.data.body && this.data.body.length? false: true
    },
    filtered: function() {
      let filtered = false
      if (this.selectedStatusValue) {
        filtered = true
      }
      return filtered
    },
    getDataRange: function(){
      return (this.count%15===0 || this.selectedPage===1) && this.count>15?this.selectedPage*15:(this.selectedPage*15-15)+(this.count%15)
    },
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      !this.resetPage ?  this.resetPage = true : this.selectedPage = 1
      this.reloadData()
    }, 500),
  },
  apollo: {

  },
  beforeCreate() {
    
  },
  async created() {
    this.$on('event-done', async () => {
      if (this.eventMeasurement) {
        // Map this data
        await this.mapData(this.measurementData);
      } 
    })
    this.$on('bast-done', async () => {
      if (this.bastloading == 0) {
        this.isLoading = false
      } 
    })
  },
  beforeMount() {
    localStorage.setItem('apollo-token', this.token)
  },
  async mounted() {
    let query = this.$route.query;
    this.replaceRouter(query)
    this.setFiltersQuery(query);
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async setFiltersQuery(query) {
      this.searchBoxValue = query.search;
      this.selectedPage = query.page ? parseInt(query.page) : 1;
      this.selectedSortValue = query.sort_by ? query.sort_by : "last_updated";
      this.selectedStatus("isFromQuery", query.status);
    },
    replaceRouter(query) {
      this.$router.replace({
        query: {
          page: query.page,
          sort_by: query.sort_by,
          status: query.status,
          search: query.search
        }
      });
    },
    reloadData(){
      this.eventMeasurement = false
      this.loadData()
    },
    async getBastOrder(id){
      this.bastloading += 1
      const  res = await  this.$apollo.query({
        query:require('@/graphql/bus/query/getBast.gql'),
        loadingKey:'loading',
        errorPolicy:'all',
        fetchPolicy:'network-only',
        variables:{
          id: id
        }
      })
      if (res.data){
        if (res.errors){
          this.handleError(res.errors, 'campaign')
        } else{
          const { busOrder } = await res.data
          if (busOrder) {
            this.bast.push(busOrder.bast)
            this.changeBastValue(busOrder.bast, id)
          }
        }
      }
    },
    changeBastValue(bast, id){
      let bastFix = this.data.body.filter(value =>{
        return value.id == id
      })
      if(bastFix.length){
        bastFix = bastFix.pop()
        bastFix.values[6].bast = bast
        bastFix.values[6].disabled = bast.length > 0 ? false : true
        this.bastloading -= 1
        this.$emit('bast-done')
      }
    },
    async loadData() {
      this.isLoading = true
      let response = null
      try {
        response = await this.$apollo.query({
          query: require('@/graphql/bus/measurementsPage.gql'),
          fetchPolicy: 'network-only',
          variables: {
            search: this.searchBoxValue || undefined,
            sort: this.selectedSortValue || undefined,
            paymentFilter: this.selectedPaymentValue || undefined,
            statusFilter: this.selectedStatusValue || undefined,
            page: this.selectedPage.toString() || "1"
          },
        })
      } catch(err) {
        this.errorNotify('Network error!')
        this.$router.push({ name: `500` })
      }
      if (response.data) {
        if (response.errors) {
          this.handleError(response.errors)
        } else {
          const { busCampaignMeasurementsPage } = response.data
          if (busCampaignMeasurementsPage){
            this.measurementData = busCampaignMeasurementsPage
            this.eventMeasurement = true
            this.$emit('event-done')
          } else{
            this.errorNotify('Something went wrong. Please refresh the page!')
            this.isLoading = false
          }
        }
      }
      this.setQueryRouter()
    },
    async handleError(error) {
      const parsedError = parseErrorGql(error)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if (parsedError.code === 204) code = 404
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          this.retryCount++
          if (this.retryCount<3) {
            await this.loadData()
          } else{
            this.isLoading = false
            this.isEmpty=true
            this.errorNotify('Something went wrong. Please refresh the page!')
          } 
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    async mapData(busCampaignMeasurementsPage){
      let body = []
      let result = busCampaignMeasurementsPage.campaignMeasurements
      let meta = busCampaignMeasurementsPage.meta
      let lenres = result.length
      let idx = 0
      this.bast = []
      if(lenres > 0){
        await result.forEach(async res => {
          let tempBast = []
          let statusDisplay = this.displayStatus(res.status)
          tempBast = this.getBastOrder(res.id)
          let valuesData = await [
            { value: res.id, display: "display:none;"},
            { value: statusDisplay.value, label: statusDisplay.label},
            { value: res.campaign},
            { start: res.start, end:res.end},
            { value: true, 
              disabled: tempBast.length > 0 ? false : true, 
              label:"BAST",
              icon: true,
              tooltip: 'Download BAST',
              bast: tempBast
            },
            { imgIcon: "/img/icons/adx-ic-eyes.svg", text: "View Detail"},
            { imgIcon: "/img/icons/adx-ic-monitoring.svg", text: "View Monitoring"},
            { imgIcon: "/img/icons/adx-ic-measurement.svg", text: "View Measurement", isDisabled: false},
          ]
          body.push({
            id: res.id,
            values:valuesData
          })
          // idx++
          // if (lenres == idx){
          //   this.isLoading = false
          // }
        });
      } else {
        this.isLoading = false
      }
      this.data.body = body
      this.maxPage = meta.maxPage
      this.count = meta.count
     
    },
    displayStatus(status) {
      return lib.displayLabelStatus(status)
    },
    async selectedSortStatus(items){
      this.selectedPage = 1;
      this.selectedSortValue = items.item.value
      await this.reloadData()
    },
    async selectedStatus(item, query){
      if( item == 'isFromQuery'){
        let labelIndex = null
        switch(query) {
        case 'upcoming':
          labelIndex = 1
          break;
        case 'active':
          labelIndex = 2
          break;
        case 'expired':
          labelIndex = 3
          break;
        }
        let status = this.statusList[labelIndex]
        if(status){
          this.selectedStatusValue = status.value
          this.labelStatus = status.label
          this.isSelected = true
        }
      }else{
        this.selectedPage = 1;
        this.selectedStatusValue = item.value
        this.selectedStatusLabel = item.id.toString()
        await this.reloadData()
      }
    },
    async resetFilter(){
      this.selectedPage = 1
      this.labelStatus = ''
      this.selectedStatusValue = ''
      this.selectedStatusLabel = ''
      this.isSelected = false
      this.getQuery()
      await this.reloadData()
    },
    selectedAction(id, type, item, imgIcon){
      let label = item.values[1].value
      let campaign = item.values[2].value

      let router_name = null
      let router_param = null
      if(imgIcon == '/img/icons/adx-ic-eyes.svg'){
        router_name = 'buscampaigndetail'
      } else if(imgIcon == '/img/icons/adx-ic-measurement.svg'){
        router_name  = 'measurementbus'
      } else{
        router_name = 'monitoringbusdetail'
      }

      router_name == 'monitoringbusdetail' 
        ? router_param = { id: item.id, campaign: campaign }
        : router_param ={ id: item.id }

      this.$router.push({
              name: router_name,
              params: router_param,
              query: this.getQuery()
        });
    },
    getQuery() {
      //get query value from variable for push route 
      return {
        page: this.selectedPage,
        sort_by: this.selectedSortValue || undefined,
        status: this.selectedStatusValue || undefined,
        search: this.searchBoxValue || undefined
      }
    },
    setQueryRouter() {
      //replace query in url
      this.$router.replace({ query: this.getQuery() });
    },
    async selectPage(item) {
      this.selectedPage = item
      this.eventBast = false
      this.eventMeasurement = false
      await this.loadData()
    },
    downloadBast(index, value, item){
      let tempBast = value.bast
      let urlBast = null
      if (tempBast.length > 0){
        urlBast = tempBast.pop().content_url
        this.$http.get(urlBast, {
          responseType: 'arraybuffer',
          headers: {
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': 'GET',
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            }
          })
        .then(response => {
          let blob = new Blob([response.data], { type: 'application/ptestdf' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = urlBast.split('/').pop()
          link.click()
        })
      }
    },
    errorNotify(message){
      this.$notify({
              group: 'saved',
              title: 'Error',
              text: (message),
              type: 'danger'
      });
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
.campainRange{
    .table table tbody tr td .text{
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 180px;
      min-width: 50px;
    }

    .table table tbody tr td .money{
      text-align: left;
    }
  }
</style>
